<template>
  <div class="ghl-contact-card">
    <div
      v-if="!isVisible"
      class="text-center py-8">
      <button
        class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium
               rounded-md text-indigo-600 bg-indigo-100 hover:bg-indigo-200 focus:outline-none
               focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        @click="loadData">
        <svg
          class="mr-2 -ml-0.5 h-4 w-4 animate-pulse"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Load Lead Contact
      </button>
    </div>

    <GhlLeadContactCard
      v-else
      :organization-id="organizationId" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import GhlLeadContactCard from './lead_contact_card.vue'

const props = defineProps({
  organizationId: {
    type: String,
    required: true
  },
  autoLoad: {
    type: Boolean,
    default: false
  }
})

const isVisible = ref(props.autoLoad)

const loadData = () => {
  isVisible.value = true
}
</script>

<style scoped>
.ghl-contact-card {
  @apply bg-white rounded-lg p-6 shadow-sm;
}
</style>
